import React from "react";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function DownloadExcel({ dataSet }) {
  return (
    <ExcelFile hideElement={true}>
      <ExcelSheet data={dataSet.sheet} name="sheet1">
        {dataSet.columns.map((col, key) => (
          <ExcelColumn label={col.label} value={col.value} key={key} />
        ))}
      </ExcelSheet>
    </ExcelFile>
  );
}
